export enum ReferenceType {
  PHONE = 'PHONE',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  EMPLOYEE_ID = 'EMPLOYEE_ID',
  AUTH0_IDENTITY = 'AUTH0_IDENTITY',
  END_USER_ID = 'END_USER_ID',
  ADMIN_USER_ID = 'ADMIN_USER_ID',
}

export interface SubjectDataReferenceItem {
  type: ReferenceType;
  value: string;
}

export interface SubjectData {
  subjectType: string;
  references: SubjectDataReferenceItem[];
  orgId?: string;
}

export enum SubjectTypeEnum {
  EMPLOYEE = 'EMPLOYEE',
  DRIVER = 'DRIVER',
  USER = 'USER',
  ASSET_OWNER = 'ASSET_OWNER',
}
